// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.booknow-wrapper {
  padding: 24px;
  background-color: #f5f5f5;
  min-height: calc(100vh - 64px);
}

.booknow-header-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  flex-wrap: wrap;
  gap: 16px;
}

.booknow-header {
  font-size: 28px;
  font-weight: 600;
  color: #1976d2;
  letter-spacing: 0.5px;
}

.btn-container {
  display: flex;
  gap: 12px;
  align-items: center;
}

.bordered-button {
  border-radius: 8px !important;
  text-transform: none !important;
  font-weight: 500 !important;
  padding: 6px 16px !important;
}

.stats-container {
  display: flex;
  gap: 20px;
  margin-bottom: 24px;
  flex-wrap: wrap;
}

.stat-card {
  flex: 1 1;
  min-width: 200px;
  padding: 20px;
  border-radius: 12px !important;
  background: white !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1) !important;
  transition:
    transform 0.2s,
    box-shadow 0.2s;
}

.stat-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
}

.stat-card h6 {
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 8px;
}

.stat-card h4 {
  font-size: 32px;
  font-weight: 600;
  color: #1976d2;
}

.filters-container {
  background: white;
  padding: 20px;
  border-radius: 12px;
  margin-bottom: 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.table-container {
  background: white;
  border-radius: 12px;
  overflow-x: auto;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.bookings-table {
  width: 100%;
  border-collapse: collapse;
  min-width: 1200px;
}

.bookings-table thead {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
}

.bookings-table th {
  padding: 16px;
  text-align: left;
  font-weight: 600;
  font-size: 14px;
  color: white;
  border-bottom: 2px solid rgba(255, 255, 255, 0.2);
}

.bookings-table td {
  padding: 14px 16px;
  border-bottom: 1px solid #e0e0e0;
  font-size: 14px;
  color: #333;
}

.bookings-table .no-data {
  text-align: center;
  padding: 60px 16px;
}

.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
}

.pagination {
  border-top: 1px solid #e0e0e0;
  padding: 12px 16px !important;
}

/* Modal Styles */
.booking-details-modal {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 90%;
  max-width: 900px;
  max-height: 85vh;
  overflow-y: auto;
  background-color: white;
  border-radius: 12px !important;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2) !important;
  animation: modalFadeIn 0.3s ease;
}

@keyframes modalFadeIn {
  from {
    opacity: 0;
    transform: translate(-50%, -48%);
  }
  to {
    opacity: 1;
    transform: translate(-50%, -50%);
  }
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
  border-bottom: 2px solid #f0f0f0;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 12px 12px 0 0;
}

.modal-header h5 {
  color: white;
  font-weight: 600;
  margin: 0;
}

.modal-header .MuiIconButton-root {
  color: white;
}

.modal-header .MuiIconButton-root:hover {
  background-color: rgba(255, 255, 255, 0.1);
}

.modal-content {
  padding: 24px;
}

.details-section {
  margin-bottom: 28px;
  padding-bottom: 20px;
  border-bottom: 1px solid #e0e0e0;
}

.details-section:last-child {
  border-bottom: none;
  margin-bottom: 0;
  padding-bottom: 0;
}

.details-section h6 {
  font-size: 18px;
  font-weight: 600;
  color: #1976d2;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.details-section h6::before {
  content: "";
  width: 4px;
  height: 20px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 2px;
  display: inline-block;
}

.details-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 16px;
}

.details-grid div {
  font-size: 14px;
  line-height: 1.6;
  color: #555;
}

.details-grid strong {
  color: #333;
  font-weight: 600;
  margin-right: 8px;
}

/* Responsive Design */
@media (max-width: 768px) {
  .booknow-wrapper {
    padding: 16px;
  }

  .booknow-header {
    font-size: 24px;
  }

  .stats-container {
    flex-direction: column;
  }

  .stat-card {
    min-width: auto;
  }

  .filters-container {
    flex-direction: column;
  }

  .filters-container .MuiFormControl-root {
    width: 100% !important;
  }

  .booking-details-modal {
    width: 95%;
    max-height: 90vh;
  }

  .details-grid {
    grid-template-columns: 1fr;
    gap: 12px;
  }

  .modal-header {
    padding: 16px;
  }

  .modal-content {
    padding: 16px;
  }
}

/* Scrollbar Styling */
.booking-details-modal::-webkit-scrollbar {
  width: 8px;
}

.booking-details-modal::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

.booking-details-modal::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 4px;
}

.booking-details-modal::-webkit-scrollbar-thumb:hover {
  background: #555;
}

/* Table scrollbar */
.table-container::-webkit-scrollbar {
  height: 8px;
}

.table-container::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

.table-container::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 4px;
}

.table-container::-webkit-scrollbar-thumb:hover {
  background: #555;
}

/* Chip animations */
.MuiChip-root {
  transition: all 0.2s ease;
}

.MuiChip-root:hover {
  transform: scale(1.02);
}

/* Button hover effects */
.bordered-button:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

/* Icon button hover */
.MuiIconButton-root:hover {
  background-color: rgba(25, 118, 210, 0.1) !important;
  transform: scale(1.05);
  transition: all 0.2s;
}

/* Status select styling */
.MuiSelect-select {
  font-size: 13px !important;
  padding: 6px 12px !important;
}

/* Snackbar styling */
.MuiAlert-root {
  border-radius: 8px !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
}

/* Dialog styling */
.MuiDialog-paper {
  border-radius: 12px !important;
  min-width: 400px;
}

@media (max-width: 600px) {
  .MuiDialog-paper {
    min-width: 90%;
    margin: 16px;
  }
}

/* Print styles for modal */
@media print {
  .booknow-header-container,
  .stats-container,
  .filters-container,
  .pagination,
  .modal-header .MuiIconButton-root {
    display: none;
  }

  .booking-details-modal {
    position: static;
    transform: none;
    width: 100%;
    max-height: none;
    box-shadow: none;
  }

  .details-section {
    page-break-inside: avoid;
    break-inside: avoid;
  }
}
`, "",{"version":3,"sources":["webpack://./src/features/EvoBookings/EvoBookings.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,+BAA+B;EAC/B,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;EACb,8BAA8B;EAC9B,4BAA4B;EAC5B,mDAAmD;EACnD;;mBAEiB;AACnB;;AAEA;EACE,2BAA2B;EAC3B,qDAAqD;AACvD;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;AACd;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,iDAAiD;AACnD;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,eAAe;EACf,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,6BAA6B;AAC/B;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,8BAA8B;EAC9B,qDAAqD;EACrD,gCAAgC;AAClC;;AAEA;EACE;IACE,UAAU;IACV,gCAAgC;EAClC;EACA;IACE,UAAU;IACV,gCAAgC;EAClC;AACF;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;EAChC,6DAA6D;EAC7D,4BAA4B;AAC9B;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,UAAU;EACV,YAAY;EACZ,6DAA6D;EAC7D,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,UAAU;IACV,gBAAgB;EAClB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;AACF;;AAEA,sBAAsB;AACtB;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA,yBAAyB;AACzB;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA,sBAAsB;AACtB;EACE,oDAAoD;EACpD,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA,0BAA0B;AAC1B;EACE,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA,qBAAqB;AACrB;EACE,6BAA6B;EAC7B,qDAAqD;AACvD;;AAEA,mBAAmB;AACnB;EACE,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE;IACE,cAAc;IACd,YAAY;EACd;AACF;;AAEA,2BAA2B;AAC3B;EACE;;;;;IAKE,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,wBAAmB;IAAnB,mBAAmB;EACrB;AACF","sourcesContent":[".booknow-wrapper {\n  padding: 24px;\n  background-color: #f5f5f5;\n  min-height: calc(100vh - 64px);\n}\n\n.booknow-header-container {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 24px;\n  flex-wrap: wrap;\n  gap: 16px;\n}\n\n.booknow-header {\n  font-size: 28px;\n  font-weight: 600;\n  color: #1976d2;\n  letter-spacing: 0.5px;\n}\n\n.btn-container {\n  display: flex;\n  gap: 12px;\n  align-items: center;\n}\n\n.bordered-button {\n  border-radius: 8px !important;\n  text-transform: none !important;\n  font-weight: 500 !important;\n  padding: 6px 16px !important;\n}\n\n.stats-container {\n  display: flex;\n  gap: 20px;\n  margin-bottom: 24px;\n  flex-wrap: wrap;\n}\n\n.stat-card {\n  flex: 1;\n  min-width: 200px;\n  padding: 20px;\n  border-radius: 12px !important;\n  background: white !important;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1) !important;\n  transition:\n    transform 0.2s,\n    box-shadow 0.2s;\n}\n\n.stat-card:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;\n}\n\n.stat-card h6 {\n  font-size: 14px;\n  font-weight: 500;\n  margin-bottom: 8px;\n}\n\n.stat-card h4 {\n  font-size: 32px;\n  font-weight: 600;\n  color: #1976d2;\n}\n\n.filters-container {\n  background: white;\n  padding: 20px;\n  border-radius: 12px;\n  margin-bottom: 24px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n}\n\n.table-container {\n  background: white;\n  border-radius: 12px;\n  overflow-x: auto;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n}\n\n.bookings-table {\n  width: 100%;\n  border-collapse: collapse;\n  min-width: 1200px;\n}\n\n.bookings-table thead {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n}\n\n.bookings-table th {\n  padding: 16px;\n  text-align: left;\n  font-weight: 600;\n  font-size: 14px;\n  color: white;\n  border-bottom: 2px solid rgba(255, 255, 255, 0.2);\n}\n\n.bookings-table td {\n  padding: 14px 16px;\n  border-bottom: 1px solid #e0e0e0;\n  font-size: 14px;\n  color: #333;\n}\n\n.bookings-table .no-data {\n  text-align: center;\n  padding: 60px 16px;\n}\n\n.loading-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 60px 20px;\n}\n\n.pagination {\n  border-top: 1px solid #e0e0e0;\n  padding: 12px 16px !important;\n}\n\n/* Modal Styles */\n.booking-details-modal {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 90%;\n  max-width: 900px;\n  max-height: 85vh;\n  overflow-y: auto;\n  background-color: white;\n  border-radius: 12px !important;\n  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2) !important;\n  animation: modalFadeIn 0.3s ease;\n}\n\n@keyframes modalFadeIn {\n  from {\n    opacity: 0;\n    transform: translate(-50%, -48%);\n  }\n  to {\n    opacity: 1;\n    transform: translate(-50%, -50%);\n  }\n}\n\n.modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 20px 24px;\n  border-bottom: 2px solid #f0f0f0;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  border-radius: 12px 12px 0 0;\n}\n\n.modal-header h5 {\n  color: white;\n  font-weight: 600;\n  margin: 0;\n}\n\n.modal-header .MuiIconButton-root {\n  color: white;\n}\n\n.modal-header .MuiIconButton-root:hover {\n  background-color: rgba(255, 255, 255, 0.1);\n}\n\n.modal-content {\n  padding: 24px;\n}\n\n.details-section {\n  margin-bottom: 28px;\n  padding-bottom: 20px;\n  border-bottom: 1px solid #e0e0e0;\n}\n\n.details-section:last-child {\n  border-bottom: none;\n  margin-bottom: 0;\n  padding-bottom: 0;\n}\n\n.details-section h6 {\n  font-size: 18px;\n  font-weight: 600;\n  color: #1976d2;\n  margin-bottom: 16px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.details-section h6::before {\n  content: \"\";\n  width: 4px;\n  height: 20px;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  border-radius: 2px;\n  display: inline-block;\n}\n\n.details-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\n  gap: 16px;\n}\n\n.details-grid div {\n  font-size: 14px;\n  line-height: 1.6;\n  color: #555;\n}\n\n.details-grid strong {\n  color: #333;\n  font-weight: 600;\n  margin-right: 8px;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .booknow-wrapper {\n    padding: 16px;\n  }\n\n  .booknow-header {\n    font-size: 24px;\n  }\n\n  .stats-container {\n    flex-direction: column;\n  }\n\n  .stat-card {\n    min-width: auto;\n  }\n\n  .filters-container {\n    flex-direction: column;\n  }\n\n  .filters-container .MuiFormControl-root {\n    width: 100% !important;\n  }\n\n  .booking-details-modal {\n    width: 95%;\n    max-height: 90vh;\n  }\n\n  .details-grid {\n    grid-template-columns: 1fr;\n    gap: 12px;\n  }\n\n  .modal-header {\n    padding: 16px;\n  }\n\n  .modal-content {\n    padding: 16px;\n  }\n}\n\n/* Scrollbar Styling */\n.booking-details-modal::-webkit-scrollbar {\n  width: 8px;\n}\n\n.booking-details-modal::-webkit-scrollbar-track {\n  background: #f1f1f1;\n  border-radius: 4px;\n}\n\n.booking-details-modal::-webkit-scrollbar-thumb {\n  background: #888;\n  border-radius: 4px;\n}\n\n.booking-details-modal::-webkit-scrollbar-thumb:hover {\n  background: #555;\n}\n\n/* Table scrollbar */\n.table-container::-webkit-scrollbar {\n  height: 8px;\n}\n\n.table-container::-webkit-scrollbar-track {\n  background: #f1f1f1;\n  border-radius: 4px;\n}\n\n.table-container::-webkit-scrollbar-thumb {\n  background: #888;\n  border-radius: 4px;\n}\n\n.table-container::-webkit-scrollbar-thumb:hover {\n  background: #555;\n}\n\n/* Chip animations */\n.MuiChip-root {\n  transition: all 0.2s ease;\n}\n\n.MuiChip-root:hover {\n  transform: scale(1.02);\n}\n\n/* Button hover effects */\n.bordered-button:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n}\n\n/* Icon button hover */\n.MuiIconButton-root:hover {\n  background-color: rgba(25, 118, 210, 0.1) !important;\n  transform: scale(1.05);\n  transition: all 0.2s;\n}\n\n/* Status select styling */\n.MuiSelect-select {\n  font-size: 13px !important;\n  padding: 6px 12px !important;\n}\n\n/* Snackbar styling */\n.MuiAlert-root {\n  border-radius: 8px !important;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;\n}\n\n/* Dialog styling */\n.MuiDialog-paper {\n  border-radius: 12px !important;\n  min-width: 400px;\n}\n\n@media (max-width: 600px) {\n  .MuiDialog-paper {\n    min-width: 90%;\n    margin: 16px;\n  }\n}\n\n/* Print styles for modal */\n@media print {\n  .booknow-header-container,\n  .stats-container,\n  .filters-container,\n  .pagination,\n  .modal-header .MuiIconButton-root {\n    display: none;\n  }\n\n  .booking-details-modal {\n    position: static;\n    transform: none;\n    width: 100%;\n    max-height: none;\n    box-shadow: none;\n  }\n\n  .details-section {\n    break-inside: avoid;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
